/**
 * Image Gallery Groups – Shopify Section JS
 */
(function () {
  const SECTION_SEL = '.gallery-groups';

  class GalleryGroupsModal {
    constructor(section) {
      this.section = section;
      this.modal = section.querySelector('.gallery-modal');
      if (!this.modal) return;

      // this.groups = JSON.parse(section.dataset.groups || '[]');
      var dataScript = section.querySelector('script[type="application/json"]');
      this.groups = dataScript ? JSON.parse(dataScript.textContent) : [];
      this.currentGroup = null;
      this.currentIndex = 0;
      this.isZoomed = false;
      this.isGridView = false;

      this.els = {
        close: this.modal.querySelector('.gallery-modal__close'),
        prev: this.modal.querySelector('.gallery-modal__nav--prev'),
        next: this.modal.querySelector('.gallery-modal__nav--next'),
        imgContainer: this.modal.querySelector('.gallery-modal__image-container'),
        img: this.modal.querySelector('.gallery-modal__image-container img'),
        groupName: this.modal.querySelector('.gallery-modal__group-name'),
        counter: this.modal.querySelector('.gallery-modal__counter'),
        thumbs: this.modal.querySelector('.gallery-modal__thumbs'),
        body: this.modal.querySelector('.gallery-modal__body'),
        grid: this.modal.querySelector('.gallery-modal__grid'),
        viewToggle: this.modal.querySelector('.gallery-modal__view-toggle'),
      };

      this._bindEvents();
    }

    _bindEvents() {
      this.section.querySelectorAll('.gallery-group-card').forEach((card) => {
        card.addEventListener('click', () => {
          const groupIndex = parseInt(card.dataset.groupIndex, 10);
          this.open(groupIndex);
        });
      });

      this.els.close.addEventListener('click', () => this.close());
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });

      this.els.prev.addEventListener('click', (e) => {
        e.stopPropagation();
        this.prev();
      });
      this.els.next.addEventListener('click', (e) => {
        e.stopPropagation();
        this.next();
      });

      this.els.imgContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleZoom();
      });

      this.els.viewToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleView();
      });

      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      let touchStartX = 0;
      this.modal.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.modal.addEventListener('touchend', (e) => {
        const diff = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.prev() : this.next();
        }
      }, { passive: true });
    }

    open(groupIndex, imageIndex = 0) {
      this.currentGroup = this.groups[groupIndex];
      if (!this.currentGroup || !this.currentGroup.images.length) return;

      this.currentIndex = imageIndex;
      this.isGridView = false;
      this.isZoomed = false;

      this._showSliderView();
      this._renderThumbs();
      this._showImage(this.currentIndex);

      this.els.groupName.textContent = this.currentGroup.name;
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
      this._resetZoom();
    }

    prev() {
      if (this.isGridView || !this.currentGroup) return;
      const total = this.currentGroup.images.length;
      this.currentIndex = (this.currentIndex - 1 + total) % total;
      this._resetZoom();
      this._showImage(this.currentIndex);
    }

    next() {
      if (this.isGridView || !this.currentGroup) return;
      const total = this.currentGroup.images.length;
      this.currentIndex = (this.currentIndex + 1) % total;
      this._resetZoom();
      this._showImage(this.currentIndex);
    }

    toggleZoom() {
      if (this.isGridView) return;
      this.isZoomed = !this.isZoomed;
      this.els.imgContainer.classList.toggle('is-zoomed', this.isZoomed);
    }

    _resetZoom() {
      this.isZoomed = false;
      this.els.imgContainer.classList.remove('is-zoomed');
    }

    toggleView() {
      this.isGridView = !this.isGridView;
      if (this.isGridView) {
        this._showGridView();
      } else {
        this._showSliderView();
        this._showImage(this.currentIndex);
      }
    }

    _showSliderView() {
      this.els.body.style.display = 'flex';
      this.els.thumbs.style.display = 'flex';
      this.els.prev.style.display = 'flex';
      this.els.next.style.display = 'flex';
      this.els.grid.classList.remove('is-visible');
      this.els.viewToggle.innerHTML = `
        <svg viewBox="0 0 24 24"><path d="M3 3h7v7H3zm0 11h7v7H3zm11-11h7v7h-7zm0 11h7v7h-7z"/></svg>
        Grid View
      `;
    }

    _showGridView() {
      this.els.body.style.display = 'none';
      this.els.thumbs.style.display = 'none';
      this.els.prev.style.display = 'none';
      this.els.next.style.display = 'none';
      this._resetZoom();

      this.els.grid.innerHTML = '';
      this.currentGroup.images.forEach((src, idx) => {
        const div = document.createElement('div');
        div.className = 'gallery-modal__grid-item';
        div.innerHTML = `<img src="${src}" alt="${this.currentGroup.name} image ${idx + 1}" loading="lazy">`;
        div.addEventListener('click', () => {
          this.isGridView = false;
          this.currentIndex = idx;
          this._showSliderView();
          this._showImage(idx);
        });
        this.els.grid.appendChild(div);
      });

      this.els.grid.classList.add('is-visible');
      this.els.counter.textContent = `${this.currentGroup.images.length} Photos`;
      this.els.viewToggle.innerHTML = `
        <svg viewBox="0 0 24 24"><path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/></svg>
        Slider View
      `;
    }

    _showImage(index) {
      const src = this.currentGroup.images[index];
      this.els.img.src = src;
      this.els.img.alt = `${this.currentGroup.name} - Image ${index + 1}`;
      this.els.counter.textContent = `${index + 1} / ${this.currentGroup.images.length}`;

      this.els.thumbs.querySelectorAll('.gallery-modal__thumb').forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) {
          t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    _renderThumbs() {
      this.els.thumbs.innerHTML = '';
      this.currentGroup.images.forEach((src, idx) => {
        const thumb = document.createElement('div');
        thumb.className = 'gallery-modal__thumb' + (idx === this.currentIndex ? ' is-active' : '');
        thumb.innerHTML = `<img src="${src}" alt="Thumb ${idx + 1}" loading="lazy">`;
        thumb.addEventListener('click', (e) => {
          e.stopPropagation();
          this.currentIndex = idx;
          this._resetZoom();
          this._showImage(idx);
        });
        this.els.thumbs.appendChild(thumb);
      });
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SEL).forEach((section) => {
      if (!section._galleryInit) {
        new GalleryGroupsModal(section);
        section._galleryInit = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SEL);
    if (section) {
      section._galleryInit = false;
      init();
    }
  });
})();